import React from 'react';
import { audience } from '../data/content';
export function ForWho() {
  return <section className="border-b border-steelLine bg-charcoal px-4 py-8 sm:py-10" data-id="element-63" data-mp="27loxx6gp755g">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="27jlwlqa3hplf">
        <h2 className="text-center text-xl text-white sm:text-3xl" data-id="element-65" data-mp="2ck08xkiqblp9">
          Who Is <span className="text-gold" data-id="element-66" data-mp="2hbi0jhyv49xk">Metal Fabrication Ready™</span> For?
        </h2>
        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-67" data-mp="2mauuemo5ih9n">
          {audience.map(item => <li key={item.title} className="flex gap-3 rounded-md border border-steelLine bg-steel p-3" data-id="element-68" data-mp="2qc6fcew2yebi">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-69" data-mp="2vb1746c0zd7r">
                {item.emoji}
              </span>
              <div data-id="element-70" data-mp="309kp5vni04uu">
                <h3 className="text-sm text-white" data-id="element-71" data-mp="309uklyrbb47x">{item.title}</h3>
                <p className="mt-0.5 text-sm font-medium leading-snug text-lightGray" data-id="element-72" data-mp="10yjojc24t19g">{item.body}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}